export default "__VITE_ASSET__DT49wjZ___"